/* FALLBACK */
import * as React from "react";
import {Button, ButtonStyles, ButtonType} from "../../../../lib/form/Button/Button";
import {useTranslation} from "react-i18next";
import {PurchaseButtonProps} from "./PurchaseButtonProps";

const FallbackButton: React.FC<PurchaseButtonProps> = () => {
  const {t} = useTranslation(["errorcodes", "translations"]);

  return (
    <Button type={ButtonType.disabled} styles={[ButtonStyles.wide]}>
      {t("general.errorOccurred")}
    </Button>
  );
};

export default FallbackButton;
